const ThemeLinksParse = (props) => {

  const TheLinks = []

  let allLinks
    
  props.map(link => {
    allLinks = link.links.split('|')
  })

  let myLinks = []

  allLinks.map(link => {
    myLinks.push(link)

    if( myLinks.length === 2 ) {
      TheLinks.push(myLinks)
      myLinks = []
    }
  })


  return TheLinks

}

export default ThemeLinksParse
